export const getUniqueColorsForSelectedSize = (childProducts, sizeUid) => {
  const uniqueColors = [];
  const seenColorUids = new Set();

  childProducts
    .filter((cp) => cp.size?.uid === sizeUid)
    .forEach((cp) => {
      if (cp.color?.uid && !seenColorUids.has(cp.color.uid)) {
        uniqueColors.push({
          uid: cp.color.uid,
          name: cp.color.name,
          hex_value: cp.color.hex_value,
        });
        seenColorUids.add(cp.color.uid);
      }
    });

  return uniqueColors;
};
